import { render, staticRenderFns } from "./PCProduct.vue?vue&type=template&id=4f9640c1&scoped=true&"
import script from "./PCProduct.vue?vue&type=script&lang=js&"
export * from "./PCProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9640c1",
  null
  
)

export default component.exports